export default "__VITE_ASSET__Cnwuh7Wi__"